import { useLoaderData, useParams } from 'react-router';
import NotFound from './NotFound';
import { useInfo } from '../context/useInfo';
import ArticleViewBase from '../components/ArticleView';
import Login from './Login';
import NoPermissions from './NoPermissions';

function ArticleView() {
    const { info } = useInfo();
    const { article: currentArticle } = useLoaderData();
    
    if (currentArticle == null || currentArticle["errorCode"] == 404) return <NotFound />

    if (currentArticle["errorCode"]) {
        if (info == null) return <Login />
        if (currentArticle["errorCode"] == 403) return <NoPermissions />
    }

    let showEditorNav = false
    if (info && info.badges.find((badge: any) => badge == 4) !== null) showEditorNav = true

    return <ArticleViewBase article={currentArticle} showEditorNav={showEditorNav} />
}

export default ArticleView